/**
 * Zentrale Tuning-Parameter fuer das Versandstatus-Polling. Wird sowohl von
 * der Belegliste (FakturierungsbelegeComponent) als auch der Beleg-Preview
 * (FakturierungsbelegePreviewComponent) konsumiert. Aenderungen hier wirken
 * automatisch in beiden Komponenten.
 */
export const VERSANDSTATUS_POLLING_CONFIG = {
  /**
   * Verzoegerung fuer den ersten Poll-Versuch nach Statuswechsel auf OFFEN.
   */
  initialDelayMs: 15_000,

  /**
   * Intervall zwischen Folge-Polls, falls noch mindestens ein Beleg im Status
   * OFFEN steht.
   */
  intervalMs: 30_000,

  /**
   * Max. Anzahl aufeinanderfolgender Polls ohne erkennbare Status-Aenderung,
   * bevor das Polling automatisch eingestellt wird. Erst eine erneute
   * Aenderung am Versandstatus startet einen neuen Zyklus.
   */
  maxAttemptsWithoutChange: 5,

  /**
   * Max. aufeinanderfolgende Fehlschlaege, bis das Polling pausiert wird.
   */
  failureThreshold: 3,

  /**
   * Maximale Cooldown-Zeit nach Circuit-Breaker-Auslösung. Der Backoff
   * verdoppelt sich pro Fehlversuchsserie (30s -> 60s -> 120s -> 240s ->
   * gedeckelt auf maxBackoffMs).
   */
  maxBackoffMs: 300_000,

  /**
   * Faktor fuer Exponential-Backoff zwischen aufeinanderfolgenden
   * Cooldown-Phasen.
   */
  backoffFactor: 2,

  /**
   * Initialer Cooldown-Wert nach Erreichen von {@link failureThreshold}.
   */
  initialBackoffMs: 30_000,

  /**
   * Random-Jitter-Anteil (0..1), der auf den Cooldown angewendet wird, um
   * Thundering-Herd zu vermeiden.
   */
  jitterRatio: 0.1,
} as const;

export type VersandstatusPollingConfig = typeof VERSANDSTATUS_POLLING_CONFIG;
